import Axios from "axios";
import { decodeJwt } from "jose";

import GitInfo from "react-git-info/macro";
import { CURRENT_USER_TOKEN } from "contexts/user";
import { showMain, unmountApp } from "./mountControl";

const gitInfo = GitInfo();

const getCurrentAccessToken = () => {
  return CURRENT_USER_TOKEN;
};

const checkTokenExpiration = (token) => {
  const decoded = decodeJwt(token);
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    return true;
  }
  return false;
};

const refreshIfExpired = (token) => {
  if (checkTokenExpiration(token)) {
    window.location.reload();
  }
};

const API = Axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
  timeout: 30000,
  params: {
    v: gitInfo.commit.hash,
  },
});

API.interceptors.request.use(
  (config) => {
    if (config.authorization !== false) {
      const token = getCurrentAccessToken();
      if (token) {
        refreshIfExpired(token);
        config.headers.set("Authorization", `Bearer ${token}`);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

/** Gate the staging mockup visibility on API auth outcomes.
 First 2xx reveals <main>; 401/403 unmounts the React tree and removes
 <main>; other 4xx/5xx/network errors pass through untouched. All actions
 are no-ops in production (no staging mockup element), and the original
 error is always re-rejected so existing .catch handlers still fire.
*/
API.interceptors.response.use(
  (response) => {
    showMain();
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      unmountApp();
    }
    return Promise.reject(error);
  },
);

export const LexMachinaSource = Symbol.for(
  "litelytics.source.__LEXMACHINA_SOURCE__",
);
export const EnrichedDocketSource = Symbol.for(
  "litelytics.source.__ENRICHED_DOCKETS_SOURCE__",
);

export function sourceFor(sourceName) {
  return Symbol.for(`litelytics.source.${sourceName}`);
}

export default API;
